var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v("Maximum Length"),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Maximum length of the text",
            "show-attributes": true,
            "show-emoji": false,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.truncate.maxLength,
            callback: function ($$v) {
              _vm.$set(_vm.clone.truncate, "maxLength", $$v)
            },
            expression: "clone.truncate.maxLength",
          },
        }),
        _vm._v(" "),
        _c("small", { staticClass: "description" }, [
          _vm._v("Enter the maximum number of characters to keep"),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v("Skip Characters"),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Number of characters to skip from the beginning",
            "show-attributes": true,
            "show-emoji": false,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.truncate.skipChars,
            callback: function ($$v) {
              _vm.$set(_vm.clone.truncate, "skipChars", $$v)
            },
            expression: "clone.truncate.skipChars",
          },
        }),
        _vm._v(" "),
        _c("small", { staticClass: "description" }, [
          _vm._v("Optional: number of characters to skip from the start"),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v("Append Ellipsis"),
        ]),
        _vm._v(" "),
        _c("a-switch", {
          model: {
            value: _vm.clone.truncate.appendEllipsis,
            callback: function ($$v) {
              _vm.$set(_vm.clone.truncate, "appendEllipsis", $$v)
            },
            expression: "clone.truncate.appendEllipsis",
          },
        }),
        _vm._v(" "),
        _c("small", { staticClass: "description" }, [
          _vm._v("Add '...' at the end of truncated text"),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }